import { ExamLog } from "../../../types/exam";

export const logUsedTime = (log: ExamLog) => {
  const { end_time, start_time } = log || {};
  if (!log || !end_time || !start_time) return "-";
  const startTime = new Date(start_time).getTime();
  const endTime = new Date(end_time).getTime();
  const totalSeconds = Math.ceil((endTime - startTime) / 1000);
  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = totalSeconds % 60;
  if (hours > 3) {
    return "3小时+";
  }
  return `${hours ? `${hours}:` : ""}${minutes ? `${minutes}:` : ""}${
    seconds ? `${seconds}` : ""
  }`;
};
